//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
//------------------------------------------------------------------------------
// Custom ----------------------------------------------------------------------
import { getValue, storeValue, removeAll } from '@helpers/localStorage';
import {
  UserStorageKey,
  AuthorizationStorageKey,
} from '@helpers/constants/localStorage';
import { handleGtmEvent } from '@helpers/gtm';
import { HeadersKey } from '@helpers/constants/api';
//------------------------------------------------------------------------------
// Exports ---------------------------------------------------------------------

export const withAuthUser = (WrappedComponent) => ({ children, ...props }) => (
  <WrappedComponent {...props} __authUser={getValue(UserStorageKey, true)}>
    {children}
  </WrappedComponent>
);

export const auth = (params = {}, skipRedirect, headers) => {
  const authUser = getValue(UserStorageKey, true) || {};

  const newAuthUser = {
    ...authUser,
    ...params,
  };

  handleGtmEvent('login', {
    eventParameters: {
      omnibus: true,
      action: 'login success',
      user_type: newAuthUser.data.professionCategory,
      user_id: newAuthUser.UID,
      method: 'Gigya',
    },
  });

  if (Object.keys(newAuthUser).length > 0) {
    storeValue(UserStorageKey, JSON.stringify(newAuthUser));
    if (headers) {
      storeValue(
        AuthorizationStorageKey,
        headers[HeadersKey.Authorization.response]
      );
    }
  } else {
    removeAll();
  }

  if (!skipRedirect) {
    window.location = '/';
  }
};

export const deauth = async (skipRedirect) => {
  const user = JSON.parse(localStorage.getItem('colgate_user'))
  handleGtmEvent('logout', {
    eventParameters: {
      omnibus: true,
      action: 'logout',
      user_id: user.UID,
      user_type: user.data.professionCategory,
      method: 'Gigya',
    }
  });

  await gigya.accounts.logout({callback:(response) => {window.location = '/'}})
  removeAll();

  if (!skipRedirect) window.location = '/';
};

export const isLoggedIn = (user) =>{
  return user && user.UID != "";
}
